import $ from 'jquery';
import React from 'react';
import PropTypes from 'prop-types';
import Swiper from 'swiper';
import StatusbarConstants from '../../../constants/statusbar_constants';
import { getMissingStatusComponent } from './missing_status/get_missing_status_component';
import { getSizeLabelComponent } from './current_status/size_label/get_size_label_component';
import { getSizeValueComponent } from './current_status/size_value/get_size_value_component';
import { EmptyLabel } from './current_status/postcode_label/empty_label';
import { EditLabel } from './current_status/postcode_label/edit_label';
import { AddPostcode } from './current_status/postcode_value/add_postcode';
import { Postcode } from './current_status/postcode_value/postcode';
import { types as productTypes } from "../../../../_constants/product/types";
import { SizeComponent } from "./current_status/size_component";
import Translation from '../../translation/translation';

class StatusbarMobile extends React.Component {
    constructor(props) {
        super(props);
        this.sliderNode = null;
        this.swiper = null;

        this.onSliderMove = this.onSliderMove.bind(this);
        this.applyWidthToGradient = this.applyWidthToGradient.bind(this);
    }

    componentDidMount() {
        this.$slider = $(this.sliderNode);
        this.$sliderWrapper = $('.swiper-wrapper', this.sliderNode);
        this.slides = $('.statusbar-mobile-current-status__slider-slide', this.sliderNode);
        this.slidesTotalWidth = this.slides.map(function () {
            return $(this).outerWidth();
        }).toArray().reduce((totalWidth, curSlideWidth) => totalWidth + curSlideWidth);
        this.$sliderGradientNode = $(this.sliderGradientNode);

        this.swiper = new Swiper(this.sliderNode, {
            freeMode: true,
            slidesPerView: 'auto',
            resistanceRatio: 0,
            onSliderMove: this.onSliderMove,
        });

    }

    componentWillUnmount() {
        this.swiper.destroy();
    }

    onSliderMove() {
        this.applyWidthToGradient();
    }

    applyWidthToGradient() {
        const sliderWidth = this.$slider.outerWidth();
        const wrapperTransformX = this.getSliderTranslateX();

        // wrapperTransformX is negative => add the value means subtract the value
        this.$sliderGradientNode.css('width', this.slidesTotalWidth - sliderWidth + wrapperTransformX);
    }

    getSliderTranslateX() {
        const transform = this.getTransform(this.$sliderWrapper);
        if (transform) {
            const matrixValues = transform.replace(/[^0-9\-.,]/g, '').split(',');
            return parseInt(matrixValues[4]); // 4 -> translateX
        } else {
            return 0;
        }
    }

    getTransform($el) {
        const possibilities = ['-webkit-transform', '-moz-transform', '-ms-transform', '-o-transform', 'transform'];
        let val = '';

        possibilities.reverse().forEach((type) => {
            const curVal = $el.css(type);

            if (curVal !== '' && curVal !== 'none') {
                val = curVal;
                return false;
            }
        });

        return val;
    }

    render() {
        const { status, filters, onChangeSpecific, onOpenFiltersClick, onAddMissingClick, onLearnMoreClick, productType } = this.props;
        const hasPostcode = !!filters.postcode;
        const showPostcode = this.props.postcodeExistsButNeedsToBeLoaded || hasPostcode;

        return (
            <div className="statusbar-mobile sticky-transition">
                {productType === productTypes.WHEEL
                    ? ''
                    : getMissingStatusComponent(status, onAddMissingClick, onLearnMoreClick)
                }

                <div className="statusbar-mobile__current-status statusbar-mobile-current-status">
                    <div className="statusbar-mobile-current-status__slider swiper-container"
                        ref={ref => this.sliderNode = ref}>
                        <div className="statusbar-mobile-current-status__slider-wrapper swiper-wrapper">
                            {
                                productType === productTypes.WHEEL
                                    ? ''
                                    : <SizeComponent status={status} filters={filters} displayDimensions={this.props.displayDimensions}
                                        onClick={() => onChangeSpecific(['sizes', 'indexes'])} />
                            }
                            <div
                                className="statusbar-mobile-current-status__postcode-section statusbar-mobile-current-status__slider-slide swiper-slide"
                                onClick={() => onChangeSpecific(['postcode'])}
                            >
                                {productType === productTypes.WHEEL ?
                                    ''
                                    : !showPostcode ?
                                        <EmptyLabel />
                                        : <EditLabel />
                                }
                                {productType === productTypes.WHEEL ?
                                    ''
                                    : !showPostcode ?
                                        <AddPostcode
                                            onlyPostcodeMissing={status === StatusbarConstants.POSTCODE_MISSING}
                                            status={status} />
                                        : <Postcode postcode={filters.postcode} />
                                }
                            </div>
                        </div>
                    </div>
                    <div className="statusbar-mobile-current-status__slider-gradient" onClick={onOpenFiltersClick}
                        ref={ref => this.sliderGradientNode = ref} />
                    <div className="statusbar-mobile-current-status__open-filters" onClick={onOpenFiltersClick} />
                    <div className="statusbar-mobile-current-status__postcode-label" style={{ position: 'absolute', top: '8px', right: '10px' }} onClick={onOpenFiltersClick} >
                        <Translation translationKey='catalog-filters-headline-default' />
                    </div>
                </div>
            </div>
        );
    }
}

StatusbarMobile.propTypes = {
    status: PropTypes.string.isRequired,
    filters: PropTypes.object.isRequired,
    postcodeExistsButNeedsToBeLoaded: PropTypes.bool.isRequired,
    onChangeSpecific: PropTypes.func.isRequired,
    onOpenFiltersClick: PropTypes.func.isRequired,
    onAddMissingClick: PropTypes.func.isRequired,
    onLearnMoreClick: PropTypes.func.isRequired,
    productType: PropTypes.string.isRequired,
    displayDimensions: PropTypes.string,
};

StatusbarMobile.defaultProps = {
    displayDimensions: '',
};


export { StatusbarMobile };
